/**
 * Mon Theme — main frontend script.
 * Compiled by Gulp into assets/js/main.min.js
 */

jQuery(document).ready(function ($) {

    // ─── GSAP plugins ────────────────────────────────────────────────────────
    gsap.registerPlugin(SplitText, ScrollTrigger, ScrollToPlugin);

    // Offset applied when scrolling to an anchor (breathing room from the top).
    const SCROLL_OFFSET = 60;


    // ─── Smooth-scroll for in-page anchor links ───────────────────────────────
    $(document).on(
        'click',
        'a[href*="#"]:not([href="#"]):not([href="#0"])',
        function (e) {
            const hash = this.hash;
            if (!hash) return;

            const samePage =
                location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
                location.hostname === this.hostname;
            if (!samePage) return;

            let target;
            try {
                target = document.querySelector(hash);
            } catch (err) {
                return;
            }
            if (!target) return;

            e.preventDefault();

            gsap.to(window, {
                duration: 1,
                ease: 'power2.inOut',
                scrollTo: {y: target, offsetY: SCROLL_OFFSET},
            });

            if (window.history && window.history.pushState) {
                window.history.pushState(null, '', hash);
            }
        }
    );


    // ─── Video players ────────────────────────────────────────────────────────
    document.querySelectorAll('.mon-video__player').forEach(el => {
        const id = el.dataset.videoId;
        let thumb = `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
        const poster = el.dataset.posterUrl;
        thumb = poster ? poster : thumb;

        el.innerHTML = `
            <div class="mon-video__preview">
                <img src="${thumb}" alt="poster">
                <button class="mon-video__play">
                    <svg width="70" height="50" viewBox="0 0 70 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="16.1543" y="11.3054" width="43.0769" height="30.1538" fill="white"/>
                        <path d="M55.4619 0H14.5381C6.50892 0 0 6.50892 0 14.5381V34.9957C0 43.0248 6.50892 49.5338 14.5381 49.5338H55.4619C63.4911 49.5338 70 43.0248 70 34.9957V14.5381C70 6.50892 63.4911 0 55.4619 0ZM45.6299 25.7622L26.4885 34.8915C25.9784 35.1348 25.3893 34.7629 25.3893 34.1979V15.3687C25.3893 14.7956 25.9939 14.4242 26.505 14.6833L45.6464 24.3832C46.2155 24.6715 46.2057 25.4877 45.6299 25.7622Z" fill="#FF0000"/>
                    </svg>
                </button>
            </div>
        `;

        el.addEventListener('click', () => {
            el.innerHTML = `
                <iframe
                    src="https://www.youtube.com/embed/${id}?autoplay=1"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen>
                </iframe>
            `;
        });
    });


    // ─── Swiper: mon-slider ───────────────────────────────────────────────────
    document.querySelectorAll('.mon-slider .swiper').forEach(slider => {
        const wrapper = slider.closest('.mon-slider-box');
        const next = wrapper.querySelector('.swiper-button-next');
        const prev = wrapper.querySelector('.swiper-button-prev');
        const slidesCount = slider.querySelectorAll('.swiper-slide').length;

        new Swiper(slider, {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 20,
            loop: slidesCount > 2,
            lazy: true,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                681: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                    spaceBetween: 24,
                }
            }
        });
    });


    // ─── Swiper: logos-slides ─────────────────────────────────────────────────
    document.querySelectorAll('.logos-slides .swiper').forEach(slider => {
        const swiperWrapper = slider.querySelector('.swiper-wrapper');
        const originalSlides = Array.from(swiperWrapper.querySelectorAll('.swiper-slide'));
        const slidesCount = originalSlides.length;
        const isDesktop = window.innerWidth >= 1025;
        const minRequired = 4;

        if (slidesCount < minRequired && !isDesktop) {
            let i = 0;
            while (swiperWrapper.querySelectorAll('.swiper-slide').length < minRequired) {
                const clone = originalSlides[i % slidesCount].cloneNode(true);
                clone.setAttribute('aria-hidden', 'true');
                swiperWrapper.appendChild(clone);
                i++;
            }
        }

        new Swiper(slider, {
            loop: true,
            watchSlidesProgress: true,
            slidesPerView: 1.16,
            spaceBetween: 12,
            autoplay: isDesktop ? {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            } : false,
            breakpoints: {
                681: {
                    slidesPerView: 2.2,
                },
                1025: {
                    slidesPerView: 3,
                }
            }
        });
    });


    // ─── Fancybox ─────────────────────────────────────────────────────────────

    document.querySelectorAll('.mon-slider').forEach((slider, index) => {
        const id = slider.dataset.sliderId;
        Fancybox.bind(`[data-fancybox="mon-slider-${id}"]`, {
            animated: true,
            dragToClose: true,
            Toolbar: {
                display: {
                    left: [],
                    middle: [],
                    right: ['close']
                }
            }
        });
    });



    // ─── Scroll-to-top button ─────────────────────────────────────────────────
    const btn = document.querySelector('.scroll-to-top');
    const header = document.querySelector('header');
    const footer = document.querySelector('footer');

    function updateButtonVisibility() {
        const scrollY = window.scrollY;
        const headerBottom = header.offsetTop + header.offsetHeight;
        const footerTop = footer.offsetTop;
        const inBetween = scrollY > headerBottom && scrollY < (footerTop - window.innerHeight);
        btn.classList.toggle('is-visible', inBetween);
    }

    window.addEventListener('scroll', updateButtonVisibility);
    window.addEventListener('resize', updateButtonVisibility);
    updateButtonVisibility();


    // ─── Balance cards ────────────────────────────────────────────────────────
    function balanceCards(selector) {
        document.querySelectorAll(selector).forEach(container => {
            const items = Array.from(container.children);
            const count = items.length;

            items.forEach(el => {
                el.style.flexBasis = '';
                el.style.flexGrow = '';
            });

            if (window.innerWidth <= 681) {
                items.forEach(el => {
                    el.style.flexBasis = 'calc(50% - 6px)';
                    el.style.flexGrow = '0';
                });
                return;
            }

            let rows = [];
            if (count <= 3) {
                rows.push(items);
            } else {
                let remaining = count;
                let index = 0;
                while (remaining > 0) {
                    if (remaining <= 3) {
                        rows.push(items.slice(index, index + remaining));
                        break;
                    }
                    rows.push(items.slice(index, index + 3));
                    index += 3;
                    remaining -= 3;
                }
            }

            rows.forEach(row => {
                const basis = 100 / row.length;
                row.forEach(el => {
                    el.style.flexBasis = `calc(${basis}% - 16px)`;
                    el.style.flexGrow = '1';
                });
            });
        });
    }

    balanceCards('.info-cards__items');
    window.addEventListener('resize', () => balanceCards('.info-cards__items'));


    // ─── GSAP animations ──────────────────────────────────────────────────────
    function initAnimations() {

        document.querySelectorAll('.gsap-hidden').forEach(el => {
            el.classList.remove('gsap-hidden');
        });

        gsap.utils.toArray([
            ".site-header__text",
            ".chapter",
            ".mon-article__description",
            ".mon-video",
            ".info-cards",
        ]).forEach((el) => {
            gsap.from(el, {
                y: 50,
                autoAlpha: 0,
                duration: 0.8,
                scrollTrigger: {
                    trigger: el,
                    start: "top 85%",
                    toggleActions: "play reverse play reverse"
                }
            });
        });

        gsap.from('.main-navigation .menu-item', {
            autoAlpha: 0,
            y: 10,
            duration: 0.5,
            ease: 'power2.out',
            stagger: 0.2,
            scrollTrigger: {
                trigger: '.main-navigation',
                start: 'top 85%',
                toggleActions: 'play reverse play reverse'
            }
        });

        if (document.querySelector('.mon-article')) {
            gsap.utils.toArray(".mon-article").forEach((section) => {
                const isReverted = section.classList.contains("reverted");
                const mainX = isReverted ? 100 : -100;
                const statsX = isReverted ? -100 : 100;

                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: "top 80%",
                        toggleActions: "play reverse play reverse"
                    }
                });

                tl.from(section.querySelector(".mon-article__main"), {
                    x: mainX,
                    autoAlpha: 0,
                    duration: 1
                });

                tl.from(section.querySelector(".mon-article__stats"), {
                    x: statsX,
                    autoAlpha: 0,
                    duration: 1
                }, "<");
            });
        }

        const mm = gsap.matchMedia();

        if (document.querySelector('.frame')) {
            mm.add("(min-width: 1025px)", () => {
                const anim = gsap.to(".frame", {
                    "--x": "80px",
                    "--y": "150px",
                    duration: 6,
                    ease: "sine.inOut",
                    repeat: -1,
                    yoyo: true
                });
                return () => { anim.kill(); };
            });
        }

        gsap.utils.toArray([
            ".frame .wrapper",
            ".info-cards__item",
            ".mon-slider",
            ".mon-quotes__item",
            ".logos-slides"
        ]).forEach((el) => {
            gsap.from(el, {
                autoAlpha: 0,
                scale: 0.85,
                filter: "blur(10px)",
                duration: 1.2,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 85%",
                    toggleActions: "restart none restart none",
                    onLeaveBack: () => {
                        gsap.set(el, {
                            autoAlpha: 0,
                            scale: 0.8,
                            filter: "blur(10px)"
                        });
                    }
                }
            });
        });

        document.querySelectorAll('.info-cards__item span').forEach(el => {
            const text = el.textContent;
            const match = text.match(/\d+/);
            if (!match) return;

            const finalValue = parseInt(match[0], 10);
            const currentWidth = el.offsetWidth;

            el.style.display = 'inline-block';
            el.style.minWidth = currentWidth + 5 + 'px';

            const obj = {value: 0};

            gsap.to(obj, {
                value: finalValue,
                duration: 1.3,
                ease: "power2.out",
                snap: {value: 1},
                onUpdate() {
                    el.textContent = text.replace(match[0], obj.value);
                },
                scrollTrigger: {
                    trigger: el,
                    start: "top 80%",
                    toggleActions: "restart none restart none",
                    invalidateOnRefresh: true
                }
            });
        });

        ScrollTrigger.refresh();
    }

    if (document.readyState === 'complete') {
        initAnimations();
    } else {
        window.addEventListener('load', initAnimations);
    }

});